// extracted by mini-css-extract-plugin
export default {"grayText":"Header_grayText__9zlST","subrayado":"Header_subrayado__jyBuP","subrayado-activo":"Header_subrayado-activo__kucTO"};